import { useSyncExternalStore } from "react";

// Whether `deadline` (epoch ms) has passed. For staleness windows (“sync
// started less than N ms ago”), pass `startedAt + N`. A null deadline reads
// as not passed. The wall clock is read fresh on every render, so any
// re-render self-corrects — the subscription’s timeout (plus a visibility
// listener, because timers suspend during system sleep while wall time keeps
// going) only guarantees the flip on an otherwise-idle page.
export function useDeadlinePassed(deadline: number | null): boolean {
  const subscribe = (onChange: () => void) => {
    if (deadline == null) return () => {};
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const arm = () => {
      const remaining = deadline - Date.now();
      if (remaining > 0) timeout = setTimeout(arm, remaining);
      else onChange();
    };
    arm();
    document.addEventListener("visibilitychange", onChange);
    return () => {
      clearTimeout(timeout);
      document.removeEventListener("visibilitychange", onChange);
    };
  };
  return useSyncExternalStore(
    subscribe,
    () => deadline != null && Date.now() >= deadline
  );
}
